import { FETCH_REGION, GET_REGION, CREATE_REGION, UPDATE_REGION, DELETE_REGION } from 'actions/address';
import * as _ from 'lodash';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  regions: [],
  regionDetail: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const regionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_REGION.REQUEST:
    case GET_REGION.REQUEST:
    case CREATE_REGION.REQUEST:
    case DELETE_REGION.REQUEST: {
      return { ...state, isLoading: true, regionDetail: {} };
    }

    case UPDATE_REGION: {
      return { ...state, isLoading: true };
    }

    case FETCH_REGION.SUCCESS: {
      if (payload.page === 1) {
        return {
          ...state,
          isLoading: false,
          regions: payload.results,
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          regions: _.concat(state.regions, payload.results),
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
        };
      }
    }

    case GET_REGION.SUCCESS: {
      return {
        ...state,
        regionDetail: payload,
        isLoading: false,
      };
    }

    case CREATE_REGION.SUCCESS: {
      toast.success('Region added successfully');
      return {
        ...state,
        regions: _.concat(state.regions, payload),
        isLoading: false,
      };
    }

    case UPDATE_REGION.SUCCESS: {
      toast.success('Region updated successfully');
      return {
        ...state,
        regions: state.regions.map((data) => (data.id === payload.id ? payload : data)),
        isLoading: false,
      };
    }

    case DELETE_REGION.SUCCESS: {
      toast.success('Region deleted successfully');
      return {
        ...state,
        regions: state.regions.filter((data) => data.id !== payload),
      };
    }

    case FETCH_REGION.FAIL:
    case GET_REGION.FAIL:
    case CREATE_REGION.FAIL:
    case UPDATE_REGION.FAIL:
    case DELETE_REGION.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default regionReducer;
